module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"postAnnotationsButton.text":"Add Annotation","postAnnotationsButton.errorMessage":"There was an error encountered while creating this annotation. If anything does not look right please contact support so we can help you :)"}}')
  delete Component.options._Ctor
}
